import React, { useContext } from 'react';
import CalendarHeader from '../Calendar/CalendarHeader';
import CalendarGrid from '../Calendar/CalendarGrid';
import '../../styles/mainContent.scss'
import { CalendarContext } from '../../context/CalendarContext';
import { eachDayOfInterval, format, isSameDay } from 'date-fns';

const MainContent = () => {
  const { startOfWeek, endOfWeek, weekDay } = useContext(CalendarContext);
  const days = eachDayOfInterval({ start: startOfWeek, end: endOfWeek })

  const emojis = ["💆‍♀️", "🧟‍♂️", "☕", "🐫", "🧠", "🍸", "🎉"]

  return (
    <div className='main-content'>
      <div className='full-header-container'>
        <CalendarHeader />
        <div className='main-calendar-header'>
          <span></span>
          {days.map((day, index) => (
            <span key={index}> {emojis[index]} {format(day, 'EEE')}<span className={`${isSameDay(day, weekDay) && 'calendar-header-current-day-number'}`}>{format(day, 'dd')}</span></span>
          ))}
        </div>
      </div>
      <CalendarGrid />
    </div>
  );
};

export default MainContent;
